import React, { useEffect, useState } from 'react'
import {
  Grid,
  CircularProgress,
  useTheme,
  useMediaQuery,
  Divider,
  Box
} from '@mui/material'
import { TextBold, TextRegular } from '../../../commonComponents/TextStyling'
import NoRecordFound from '../../../commonComponents/NoRecordFound'
import serverData from '../../../api/ServerData'
import { logoutUser } from '../../../actions/loginActions'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import AppButton from '../../../commonComponents/AppButton'
import appassets from '../../../utils/appassets'

export default function JobViewComponent () {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    serverData.getDashboardData(
      {},
      result => {
        if (result.status) setData(result.response)
        setLoading(false)
      },
      error => {
        setLoading(false)
        if (error.status === 401) dispatch(logoutUser(navigate))
      }
    )
  }, [])

  const actionButtons = [
    {
      key: 'pendingReview',
      label: 'Pending Review',
      status: 'pendingAtEmployer'
    },
    {
      key: 'underConsideration',
      label: 'Under Consideration',
      status: 'underConsideration'
    },
    { key: 'totalApplications', label: 'Total Applications', status: '' }
  ]

  return (
    <Grid container spacing={2}>
      {loading ? (
        <Grid
          item
          xs={12}
          container
          justifyContent='center'
          alignItems='center'
          style={{ height: '50vh' }}
        >
          <CircularProgress />
        </Grid>
      ) : data.length > 0 ? (
        data.map((item, idx) => (
          <Grid
            key={idx}
            item
            xs={12}
            sx={{
              backgroundColor: theme.palette.background.paper,
              borderRadius: 2,
              p: 3,
              mt: 3
            }}
          >
            <Grid container spacing={isMobile ? 2 : 4}>
              {/* Left half */}
              <Grid item xs={12} md={6}>
                <TextBold
                  sx={{
                    fontSize: 22,
                    color: theme.palette.primary.main,
                    fontWeight: '700'
                  }}
                >
                  {item.jobTitle}
                </TextBold>

                <Grid
                  container
                  sx={{
                    mt: 1,
                    mb: 2
                  }}
                >
                  <Grid item display='flex' alignItems='center'>
                    <Box
                      component='img'
                      src={appassets.location}
                      sx={{ mr: 1 }}
                    />
                    <TextRegular sx={{ fontSize: 15, color: 'text.secondary' }}>
                      {item.city}
                    </TextRegular>
                  </Grid>
                  <Grid item display='flex' sx={{ ml: 2 }} alignItems='center'>
                    <Box component='img' src={appassets.time} sx={{ mr: 1 }} />
                    <TextRegular sx={{ fontSize: 15, color: 'text.secondary' }}>
                      {moment(item.createdAt).fromNow()}
                    </TextRegular>
                  </Grid>
                </Grid>

                {/* Views / Referrals / Shares */}
                <Grid
                  container
                  alignItems='center'
                  sx={{
                    mt: 2,
                    justifyContent: isMobile ? 'space-around' : 'flex-start'
                  }}
                >
                  {['Views', 'Referrals', 'Shares'].map((label, i) => {
                    const value =
                      [item.views, item.refferals, item.shares][i] || 0
                    return (
                      <React.Fragment key={label}>
                        <Grid item>
                          <TextRegular
                            sx={{ fontSize: 14, color: 'text.secondary' }}
                          >
                            {value} &nbsp; {label}
                          </TextRegular>
                        </Grid>
                        {i < 2 && (
                          <Divider
                            orientation='vertical'
                            flexItem
                            sx={{
                              mx: isMobile ? 0.5 : 2,
                              bgcolor: 'text.secondary'
                            }}
                          />
                        )}
                      </React.Fragment>
                    )
                  })}
                </Grid>
              </Grid>

              {/* Right half */}
              <Grid item xs={12} md={6}>
                <Grid
                  container
                  spacing={2}
                  alignItems='flex-start'
                 justifyContent="space-between" 
                >
                  {actionButtons.map(({ key, label, status }) => {
                    const value = item[key] || 0
                    return (
                      <Grid
                        key={key}
                        item
                        xs
                        // xs={4}
                        // sm={4}
                        // md={2}
                        container
                        flexDirection='column'
                        alignItems='center'
                        sx={{ textAlign: 'center' }}
                      >
                        <TextRegular
                          sx={{ fontSize: 14, color: 'text.secondary', mb: 1 }}
                        >
                          {label}
                        </TextRegular>
                        <TextBold sx={{ fontSize: 32, mb: 1 }}>
                          {value}
                        </TextBold>
                        {value > 0 && (
                          <AppButton
                            variant='text'
                            name='Take action'
                            onClick={() =>
                              navigate('/employer/takeaction', {
                                state: { jobId: item.jobId, status }
                              })
                            }
                            style={{ fontSize: 14, fontWeight: 700 }}
                          />
                        )}
                      </Grid>
                    )
                  })}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))
      ) : (
        <Grid item xs={12} sx={{ mt: 4 }}>
          <NoRecordFound />
        </Grid>
      )}
    </Grid>
  )
}
